<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" class="position-relative" :class="[getSelectedDEV && 'dev-selected-component']">
    <img 
      class="mr-3 my-2"
      :src="schema.image"
      v-if="isImageTitle"
    />
    <div :class="{ 'position-absolute': isImageTitle }" :style="schema.stylePosition">
      <component v-if="schema.attributes.title" v-bind="schema.attributes.title" :title="dynamicTitle" :is="schema.attributes.title.tag">
        <v-icon
          v-if="schema.attributes.title.appendIcon && schema.attributes.title.appendIcon.left"
          v-bind="schema.attributes.title?.appendIcon.attributesIcon"
          @click="schema.attributes.title?.appendIcon?.hasAction && execute(schema.attributes.title.appendIcon?.actions?.items[0])"
          >{{ schema.attributes.title.appendIcon.icon }}</v-icon
        >
        {{ dynamicTitle }}
        <v-icon
          v-if="schema.attributes.title.appendIcon && schema.attributes.title.appendIcon.right"
          v-bind="schema.attributes.title.appendIcon.attributesIcon"
          >{{ schema.attributes.title.appendIcon.icon }}</v-icon
        >
      </component>

      <component v-if="schema.attributes.subTitle" v-bind="schema.attributes.subTitle" :is="schema.attributes.subTitle.tag">
        <v-icon
          v-if="schema.attributes.subTitle.appendIcon && schema.attributes.subTitle.appendIcon.left"
          v-bind="schema.attributes.subTitle.appendIcon.attributesIcon"
          >{{ schema.attributes.subTitle.appendIcon.icon }}</v-icon
        >
        {{ dynamicSubtitle }}
        <v-icon
          v-if="schema.attributes.subTitle.appendIcon && schema.attributes.subTitle.appendIcon.right"
          v-bind="schema.attributes.subTitle.appendIcon.attributesIcon"
          >{{ schema.attributes.subTitle.appendIcon.icon }}</v-icon
        >
      </component>
    </div>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import appendIconAction from '@/mixins/appendicon-action-mixins';
import { compileDynamicString } from '@/helpers/page';

export default {
  mixins: [abstractField, devComponentMixin, appendIconAction],
  computed: {
    isImageTitle() {
      if(this.schema.image) {
        return true
      } else {
        return false
      }
    },

    dynamicTitle() {
      return compileDynamicString(
        {
          page: this.formOptions.page,
          mode: this.formOptions.mode,
          originalString: this.schema.attributes.title.text
        }
      );
    },

    dynamicSubtitle() {
      return compileDynamicString(
        {
          page: this.formOptions.page,
          mode: this.formOptions.mode,
          originalString: this.value ? this.value : this.schema.attributes.subTitle.text
        }
      );
    }
  }
};
</script>
